import React from 'react';
import bgCards from '../../images/bg-cards.png';

interface HeroProps {
  title: string;
  subtitle?: string;
  text?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  fontSize?: number;
}

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  text,
  buttonText,
  onButtonClick,
  fontSize,
}) => (
  <div
    className="shadow position-relative w-100 vh-100 overflow-hidden"
    style={{
      background: '#8a7770',
      backgroundImage:
        'linear-gradient(125deg, rgb(231,226,208) 0%, rgb(219, 198, 193) 100%)',
    }}
  >
    <div className="container-md d-flex vh-100 justify-content-center align-items-center">
      <div
        className="fw-bold text-center text-primary mb-5 pb-5"
        style={{ zIndex: 1 }}
      >
        <h1
          className="fw-bold"
          style={{ fontSize: fontSize ?? 96, wordBreak: 'break-word' }}
        >
          {title}
        </h1>
        {subtitle && <h1 className="fw-bold">{subtitle}</h1>}
        {text && <p className="mt-3 px-3 fs-5">{text}</p>}
        {buttonText && (
          <button
            className="btn btn-primary mt-3 px-5 py-3 fw-bold shadow"
            type="button"
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        )}
      </div>
      <div
        className="d-block common-images"
        style={{ background: `url(${bgCards})`, backgroundSize: 'cover' }}
      />
    </div>
  </div>
);

export default Hero;
